export function calculateMonthlyAmount(totalMembers) {
  const count = Number(totalMembers || 0);
  if (count <= 1) return 50;
  return 100;
}
